import { Theme } from "@material-ui/core";
const styles = (theme: Theme) =>
({
    containerNotFound: {
      display: "flex",
      "& h4": {
        fontWeight: "400",
      },
      "& h3": {
        fontWeight: "400",
        padding: "24px 0",
      },
      "& button": {
        marginTop: 24,
      },
    },
    container: {
      padding: "24px 0",
      flex: 1,
    },
    illu: {
      flex: 1,
      width: "50%",
    },
    title: {
      "& > h2": {
        fontWeight: "300",
        paddingTop: 16,
        paddingBottom: 16,
      },
    },
  } as any);

export default styles;
